import { STREAMING_TYPE } from "@adapters/repositories/stream/IQuoteStreamRepo";
var Stream = /** @class */ (function () {
    function Stream(url, port) {
        this.reqArray = [];
        this.pendingToBeConsumed = [];
        this.url = url;
        this.port = port;
        this.WS = new WebSocket(url + ":" + port + "/websocket");
        //this.WS = new WebSocket("wss://local.nuvamawealth.com" + ":" + 8448);
    }
    Stream.prototype.WSRequest = function (req) {
        var _this = this;
        var _a;
        var resetPush = true;
        var newPayload = JSON.parse(req.payload);
        if (((_a = this.reqArray) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            this.reqArray.map(function (z, i) {
                var oldpayload = JSON.parse(z.payload);
                if (newPayload.request.request_type === "subscribe") {
                    if (oldpayload.request.streaming_type ===
                        newPayload.request.streaming_type) {
                        _this.reqArray[i] = req;
                        resetPush = false;
                    }
                }
            });
            if (newPayload.request.request_type === "subscribe" && resetPush) {
                this.reqArray.push(req);
            }
        }
        else {
            if (newPayload.request.request_type === "subscribe") {
                this.reqArray.push(req);
            }
        }
        return new Promise(function (resolve, reject) {
            var msgReadyToSend = false;
            var waitingForConn = setInterval(function () {
                if (!msgReadyToSend && _this.WS.readyState === 1) {
                    _this.WS.send(req.payload + "\n");
                    msgReadyToSend = true;
                }
                else {
                    clearInterval(waitingForConn);
                }
            }, 100);
            setInterval(function () {
                if (_this.pendingToBeConsumed.length > 0)
                    _this.handleBrokenPackets(_this.pendingToBeConsumed.pop());
            }, 0);
            //heart beat pinged every two minutes to keep the socket connection alive, not related to request
            // setInterval(() => {
            //   if (this.WS.readyState === 1) this.WS.send(JSON.stringify({}) + "\n");
            // }, 120000);
            _this.WS.onopen = function (_e) {
                try {
                    // WS.readyState
                    if (_this.WS.readyState === 1 && !msgReadyToSend) {
                        _this.WS.send(req.payload + "\n");
                        msgReadyToSend = true;
                    }
                    resolve(_this.WS);
                }
                catch (e) {
                    reject(e);
                }
            };
            _this.WS.onmessage = function (e) {
                // console.log(
                //   JSON.parse(e.data).response.data.lut,
                //   new Date().toTimeString(),
                //   this.pendingToBeConsumed.length
                // );
                if (JSON.parse(e.data).response.streaming_type ===
                    STREAMING_TYPE.MINIQUOTE
                // ||
                // JSON.parse(e.data).response.streaming_type === STREAMING_TYPE.QUOTE
                ) {
                    if (_this.pendingToBeConsumed.length < 200) {
                        var index = _this.pendingToBeConsumed.findIndex(function (x) {
                            return x.includes(JSON.parse(e.data).response.data.sym);
                        });
                        if (index === -1) {
                            _this.pendingToBeConsumed.push(e.data);
                        }
                        else {
                            _this.pendingToBeConsumed[index] = e.data;
                        }
                    }
                }
                else {
                    _this.handleBrokenPackets(e.data);
                }
                //this.handleBrokenPackets(e.data);
            };
            _this.WS.onclose = function (e) {
                console.log("Connection closed ");
                console.log("Initiated Connection");
                _this.reconnection();
            };
            _this.WS.onerror = function (e) {
                console.log("Connection errored ", e);
                console.log("Initiated Connection");
                _this.reconnection();
            };
        });
    };
    //to close webscoket connection from client end
    Stream.prototype.reconnection = function () {
        var _this = this;
        var createConnection = setInterval(function () {
            if (_this.WS.readyState === _this.WS.CLOSED) {
                _this.WS = new WebSocket(_this.url + ":" + _this.port + "/websocket");
            }
            if (_this.WS.readyState === _this.WS.OPEN) {
                _this.reqArray.map(function (req) {
                    _this.WSRequest(req);
                });
                clearInterval(createConnection);
            }
        }, 1000 * 3);
        setTimeout(function () {
            clearInterval(createConnection);
        }, 1000 * 60);
    };
    Stream.prototype.handleBrokenPackets = function (resData) {
        // const arrayToBeConsumed: string[] = [];
        // let readData = resData;
        // if (this.pendingToBeConsumed.length > 0) {
        //   readData = this.pendingToBeConsumed + readData;
        //   this.pendingToBeConsumed = "";
        // }
        // let arr1 = readData.split("\n");
        // arrayToBeConsumed.push(...arr1.slice(0, arr1.length - 1));
        // if (!readData.endsWith("\n")) {
        //   this.pendingToBeConsumed = arr1[arr1.length - 1];
        // }
        this.reqArray.map(function (z, i) {
            var _a, _b;
            var oldpayload = JSON.parse(z.payload);
            // arrayToBeConsumed.map((x) => {
            var respData = JSON.parse(resData);
            if (((_a = oldpayload === null || oldpayload === void 0 ? void 0 : oldpayload.request) === null || _a === void 0 ? void 0 : _a.streaming_type) ===
                ((_b = respData === null || respData === void 0 ? void 0 : respData.response) === null || _b === void 0 ? void 0 : _b.streaming_type)) {
                z.message(resData);
            }
            // });
        });
    };
    return Stream;
}());
export default Stream;
